import React, { useMemo } from 'react';
import moment from 'moment';
import { GetAssureDetailsResponse } from 'api/actor';
import { EntityDetailsStat, EntityDetailsStatConfig } from 'components/display/EntityDetailsStat';

interface PersonDetailsStatProps {
  personDetails: GetAssureDetailsResponse;
  className?: string;
}

const PersonDetailsStat: React.FC<PersonDetailsStatProps> = ({
  personDetails,
  className = ''
}) => {
  const config: EntityDetailsStatConfig = useMemo(() => {
    const header = personDetails.header;

    const allStats = [
      {
        label: 'Statut',
        value: header?.status
      },
      {
        label: 'Type de personne',
        value: header?.personType
      },
      {
        label: 'Client depuis',
        value: header?.customerSince
          ? moment(header.customerSince).format('DD MMM YYYY')
          : undefined
      },
      {
        label: 'Prochain terme',
        value: header?.nextTermDate
          ? moment(header.nextTermDate).format('DD MMM YYYY')
          : undefined
      },
      {
        label: 'Nombre de contrats',
        value:
          header?.contractsCount && header.contractsCount > 0
            ? header.contractsCount.toString()
            : undefined
      },
      {
        label: 'Produits',
        value:
          header?.products && header.products.length > 0
            ? header.products.join(', ')
            : undefined
      }
    ];

    // Filter out stats with no value
    const stats = allStats.filter(
      (stat) => stat.value && stat.value !== '-'
    ) as { label: string; value: string }[];

    return {
      stats,
      emptyStateConfig: {
        message: 'Aucune information disponible pour cette personne'
      },
      gridConfig: {
        mobile: 'flex gap-3 overflow-x-auto pb-2',
        desktop: 'grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-6 gap-4'
      }
    };
  }, [personDetails]);

  return <EntityDetailsStat config={config} className={className} />;
};

export default PersonDetailsStat;
